import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactToPrint from 'react-to-print';
import { Button } from '@material-ui/core';

class ComponentToPrint extends React.Component {
    render() {
        return (
            <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
        );
    }
}

ComponentToPrint.propTypes = {
    content: PropTypes.string
};

const PrintComponent = (props) => {
    const { getPrintContent } = props;

    const printRef = useRef(null);
    const [printContent, setPrintContent] = useState(null);

    const handleGetPrintContent = async () => {
        const response = await getPrintContent();
        setPrintContent(response);
    }

    return (
            <>
                <div style={{ display: 'none' }}><ComponentToPrint content={printContent} ref={printRef} /></div>
                <ReactToPrint
                    onBeforeGetContent={handleGetPrintContent}
                    trigger={() => <Button color="primary">Štampa</Button>}
                    content={() => printRef.current}
                />
            </>
    )
}

PrintComponent.propTypes = {
    getPrintContent: PropTypes.func
};

export default PrintComponent;
